import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询贴图包列表
export const queryTextures: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setTextures', { ...state.list, loading: true });
    // baseinfo/texturepackage/download/list 用于 lancher 检查
    // const res: IPageData = await $http.post('/baseinfo/texturepackage/list', payload);
    const res: IPageData = await $http.post('/v1/ue/texture/list', payload);
    commit('setTextures', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setTextures', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询贴图包子列表
export const queryPakFiles: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('queryPakFiles', { ...state.sublist, loading: true });
    const res: IPageData = await $http.post('/v1/data/ue/texture/pakfilelist', payload);
    commit('queryPakFiles', { data: res, total: res.total });
  } catch (e) {
    commit('queryPakFiles', { data: [], total: 0 });
  }
};

// 查询贴图包操作日志
export const queryTextureLogs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setTextureLogs', { data: [], loading: true });
    // const res: IPageData = await $http.get(`/baseinfo/texturepackage/${payload}/log`);
    const res: IPageData = await $http.get(`/v1/ue/texture/${payload}/log`);
    commit('setTextureLogs', { data: res });
  } catch (e) {
    commit('setTextureLogs', { data: [] });
  }
};

// 查询贴图包类型列表
export const queryTextureTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setTextureTypes', { ...state.types, loading: true });
    const res: IPageData = await $http.get('/common/chooseoptions/PackageType');
    commit('setTextureTypes', { data: res });
  } catch (e) {
    commit('setTextureTypes', { data: [] });
  }
};

// 查询 launcher 启动时需要下载的贴图包列表
export const queryDownloadList: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setDownloadList', { ...state.downloads, loading: true });
    // const res = await $http.get('/baseinfo/texturepackage/download/list');
    const res = await $http.get('/v1/ue/texture/downloadlist');
    commit('setDownloadList', { data: res });
  } catch (e) {
    commit('setDownloadList', { data: [] });
  }
};
// 编辑贴图包
export const editTexture: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/baseinfo/texturepackage/modify', payload);
    await $http.post('/v1/ue/texture/modify', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除贴图包
export const deleteTexture: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.get(`/baseinfo/texturepackage/delete/${payload}`);
    await $http.post('/v1/ue/texture/delete', { id: payload });
  } catch (e) {
    if (e?.rtnCode === 8002) {
      const data = JSON.parse(e.message || '[]');
      commit('setDialog', { visible: true, type: 'error', data });
    }
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量转换贴图包类型
export const transPakType: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    // const postUrl = `/baseinfo/texturepackage/${payload.toType}`;
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post(postUrl, payload);
    await $http.post('/v1/ue/texture/converttype', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

